// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"409ef681","154":"d477c8c6","670":"7fc96f84","722":"1dcccc34","790":"8f630347","801":"1caf767b"}[chunkId] + ".chunk.js";
};